// src/pages/Home/Home.jsx
import React, { useState, useEffect } from 'react';
import Hero from '../../components/Hero/Hero';
import ProductGrid from '../../components/ProductGrid/ProductGrid';
import HowItWorks from '../../components/HowItWorks/HowItWorks';
// import StatsCounter from '../../components/StatsCounter/StatsCounter';
import Testimonials from '../../components/Testimonials/Testimonials';

import FAQ from '../../components/FAQ/FAQ';
// import { getFeaturedProducts } from '../../data/products';
import './Home.css';
import Contact from '../Contact/Contact';
import { getFeaturedProducts } from '../../services/ProductService';

const Home =   ({ addToCart }) => {
  const [loading, setLoading] = useState(true);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [error, setError] = useState('');

    // Redirect to login if not authenticated
    useEffect(() => {

      const loadUserData = async () => {
        try {
          setLoading(true);
          const featuredProductsConts =  await getFeaturedProducts();
          setFeaturedProducts(featuredProductsConts);
  

        } catch (err) {
          console.error('Error loading user data:', err);
          setError('Failed to load your account data. Please try again.');
        } finally {
          setLoading(false);
        }
      };
  
      loadUserData();

    }, []);

  console.log("Printing Your Featured Products ",featuredProducts);

  return (
    <div className="home-page">
      <Hero />

      <div className="container">
        

          {featuredProducts.length > 0 ? (
              <ProductGrid
                products={featuredProducts}
                addToCart={addToCart}
                title="Featured Medications"
                viewAllLink="/shop"
              />
          ) : (
            <div className="empty-state">
              <svg viewBox="0 0 24 24">
                <path d="M22 7h-6V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H2v15h20V7zM10 5h4v2h-4V5zm1 13.5l-1-1 3-3-3-3 1-1 4 4-4 4z"/>
              </svg>
              <h3>No products found</h3>
              <p>We couldn't find any products matching your criteria.</p>
            </div>
          )}

      </div>

      {/* <StatsCounter /> */}
      <HowItWorks />
      <Testimonials />
      <Contact />
      <FAQ />
    </div>
  );
};

export default Home;
